/** The TanStack shell: the application provider tree. */
import { Suspense, lazy, type ReactNode } from "react";

import AppProviders from "@/shell/AppProviders";

const DevPanel =
  process.env.NODE_ENV === "development"
    ? lazy(() => import("@/components/DevPanel"))
    : () => null;

export default function AppShell({ children }: { children: ReactNode }) {
  return (
    <AppProviders
      scripts={
        <script
          async
          id="trust-pilot"
          src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        />
      }
      devTools={
        <Suspense fallback={null}>
          <DevPanel />
        </Suspense>
      }
    >
      {children}
    </AppProviders>
  );
}
